/**
 * 랜더링 관련 함수 모음
 * 
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */

export class FxRenderer {

	static renderDate(hstime) {
		if (hstime === null || hstime === undefined) {
			return "";
		}

		let s = hstime + "";
		if (s.length >= 8) {
			let ret =
				s.substring(0, 4) + "-" + s.substring(4, 6) + "-" + s.substring(6, 8);

			if (s.length == 14) {
				ret += " ";
				ret +=
					s.substring(8, 10) +
					":" +
					s.substring(10, 12) +
					":" +
					s.substring(12, 14);
			}
			return ret;
		} else if (s.length < 4) {
			return "-";
		} else {
			return s;
		}
	}

	static renderHH(hstime) {
		if (hstime === null || hstime === undefined) {
			return "";
		}

		let s = hstime + "";
		if (s.length >= 10) {
			return s.substring(8, 10);
		} else if (s.length === 6) {
			return s.substring(0, 2);
		} else {
			return s;
		}
	}

	static renderHHMM(hstime) {
		if (hstime === null || hstime === undefined) {
			return "";
		}

		let s = hstime + "";
		if (s.length >= 12) {
			return s.substring(8, 10) + ":" + s.substring(10, 12);
		} else if (s.length === 6) {
			return s.substring(0, 2) + ":" + s.substring(2, 4);
		} else {
			return s;
		}
	}
}
